"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGoogleCalendarLink = exports.convertDateToGoogleCalStr = exports.createICalEvent = exports.escapeICalSpecialCharacters = exports.ICalEventStatus = void 0;
const luxon_1 = require("luxon");
const quill_delta_1 = __importDefault(require("./quill-delta"));
var ICalEventStatus;
(function (ICalEventStatus) {
    ICalEventStatus["CONFIRMED"] = "CONFIRMED";
    ICalEventStatus["TENTATIVE"] = "TENTATIVE";
    ICalEventStatus["CANCELLED"] = "CANCELLED";
    ICalEventStatus["DECLINED"] = "DECLINED";
})(ICalEventStatus || (exports.ICalEventStatus = ICalEventStatus = {}));
const escapeICalSpecialCharacters = (str) => {
    return str.replace(/[\\,;]/g, '\\$&');
};
exports.escapeICalSpecialCharacters = escapeICalSpecialCharacters;
const createICalEvent = (eventData) => {
    return [
        `BEGIN:VCALENDAR\n`,
        `PRODID:-//Call Light LLC//Humla Health//EN\n`,
        `VERSION:2.0\n`,
        `METHOD:REQUEST\n`,
        ...eventData.times.flatMap(({ startTime, endTime }, i) => [
            `BEGIN:VEVENT`,
            `SUMMARY:${(0, exports.escapeICalSpecialCharacters)(eventData.title)}`,
            `DTSTART:${formatDateForICal(startTime, eventData.location.timezone)}`,
            `DTEND:${formatDateForICal(endTime, eventData.location.timezone)}`,
            `DTSTAMP:${formatDateForICal(new Date())}`,
            `UID:${eventData.id}-${i}`,
            `DESCRIPTION:${(0, exports.escapeICalSpecialCharacters)((0, quill_delta_1.default)(eventData.description))}`,
            `LOCATION:${(0, exports.escapeICalSpecialCharacters)(eventData.location.line1 +
                (eventData.location.line2
                    ? ', ' + eventData.location.line2
                    : '') +
                ', ' +
                eventData.location.city +
                ', ' +
                eventData.location.state +
                ' ' +
                eventData.location.postalCode)}`,
            `ATTENDEE;CUTYPE=INDIVIDUAL;CN=${(0, exports.escapeICalSpecialCharacters)(eventData.firstName + ' ' + eventData.lastName)};X-NUM-GUESTS=0:mailto:${(0, exports.escapeICalSpecialCharacters)(eventData.email)}`,
            `ORGANIZER;CN=Humla Health:mailto:noreply@humla.com`,
            `STATUS:${eventData.status}`,
            eventData.status === ICalEventStatus.CANCELLED
                ? `METHOD:CANCEL`
                : undefined,
            `SEQUENCE:${eventData.sequence || 0}`,
            `END:VEVENT\n`,
        ].filter(Boolean)),
        `END:VCALENDAR`,
    ].join('\n');
};
exports.createICalEvent = createICalEvent;
const formatDateForICal = (date, timezone) => {
    return (luxon_1.DateTime.fromJSDate(date, {
        zone: timezone ?? undefined,
    })
        .toJSDate()
        .toISOString()
        .replace(/[-:]/g, '')
        .split('.')[0] + 'Z');
};
const convertDateToGoogleCalStr = (date) => {
    return date.toISOString().replace(/[-:]/g, '');
};
exports.convertDateToGoogleCalStr = convertDateToGoogleCalStr;
const createGoogleCalendarLink = ({ description, endTime, facility, startTime, }) => {
    return `https://calendar.google.com/calendar/u/0/r/eventedit?text=Shift+At+${encodeURIComponent(facility.name)}&details=${encodeURIComponent((0, quill_delta_1.default)(description))}&location=${encodeURIComponent(`${facility.address.line1}${facility.address.line2 ? ', ' + facility.address.line2 : ''}, ${facility.address.city}, ${facility.address.state} ${facility.address.postalCode}`)}&dates=${(0, exports.convertDateToGoogleCalStr)(startTime)}/${(0, exports.convertDateToGoogleCalStr)(endTime)}&ctz=${facility.address.timezone}`;
};
exports.createGoogleCalendarLink = createGoogleCalendarLink;
//# sourceMappingURL=calendar-utils.js.map